function getDistinct(t){let e=[],n={};for(let i in t)objTitle=t[i].id,n[objTitle]=t[i];for(i in n)e.push(n[i]);return e}
var final_count = 0;
var related_eles = [],already_added = [];
var total_required=4, total_added=0,total_remains=0;
var getCombn = function(a, min=1) {
  var fn = function(n, src, got, all) {
    if (n == 0) {
      if (got.length > 0) {
        all[all.length] = got;
      }
      return;
    }
    for (var j = 0; j < src.length; j++) {
      fn(n - 1, src.slice(j + 1), got.concat([src[j]]), all);
    }
    return;
  }
  var all = [];
  for (var i = min; i < a.length; i++) {
    fn(i, a, [], all);
  }
  all.push(a);
  return all;
}
var global_counter=0;

function fetchRelatedProds(prod_type,color,pfabric,prod_handle,full_price){
//   console.log(prod_type,color,pfabric)
  var url ="/collections/all?view=ajax&time="+new Date().getTime();
  fetch(url)
  .then(function(response) {
    // When the page is loaded convert it to text
    return response.text()
  })
  .then(function(html) {
    var count = $(html).find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"]').length
    var products = $(html).find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"]');
    $.each(products,function(i,ele){
      var prod = {'handle':$(ele).attr('data-handle'),'data_full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
      if($(ele).attr('data-full-price')=="true"){
        fullPriceProducts.push(prod);
      }
      if($(ele).attr('data-full-price')=="false"){
        saleProducts.push(prod);
      }
    })
    
    if(full_price==true){
      
      if(prod_type != undefined && color != undefined && pfabric != undefined){
        //1 2 3
        var temp = $(html).find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"][data-prod_type="'+prod_type+'"][data-color="'+color+'"][data-fabric="'+pfabric+'"]');
        if(temp.length>0){
          $.each(temp,function(i,ele){
            var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
            var found = false;
            $.each(final_products,function(ind,val){
              if(val.handle==$(ele).attr('data-handle')){
                found = true;
                return false;
              }
            })
            if(found==false){
              if($(ele).attr('data-full-price')=="true"){
                final_products.push(prod)
              }
              if(final_products.length>=4){return false;}
            }
          })
          if(temp.length<4){
            $.each(temp,function(i,ele){
              var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
              var found = false;
              $.each(final_products,function(ind,val){
                if(val.handle==$(ele).attr('data-handle')){
                  found = true;
                  return false;
                }
              })
              if(found==false){
                if($(ele).attr('data-full-price')=="false"){
                  final_products.push(prod)
                }
                if(final_products.length>=4){return false;}
              }
            })
          }
        }
//         console.log('1 2 3',"final_products.length "+final_products.length);
      }
      
      if(final_products.length<4){
        if(prod_type != undefined && pfabric != undefined){
          //1 3
          var temp = $(html).find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"][data-prod_type="'+prod_type+'"][data-fabric="'+pfabric+'"]');
          if(temp.length>0){
              $.each(temp,function(i,ele){
                var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};

                var found = false;
                $.each(final_products,function(ind,val){
                  if(val.handle==$(ele).attr('data-handle')){
                    found = true;
                    return false;
                  }
                })
                if(found==false){
                  if($(ele).attr('data-full-price')=="true"){
                    final_products.push(prod)
                  }
                  if(final_products.length>=4){return false;}
                }
              })
              if(temp.length<4){
              $.each(temp,function(i,ele){
                var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
                var found = false;
                $.each(final_products,function(ind,val){
                  if(val.handle==$(ele).attr('data-handle')){
                    found = true;
                    return false;
                  }
                })
                if(found==false){
                  if($(ele).attr('data-full-price')=="false"){
                    final_products.push(prod)
                  }
                  if(final_products.length>=4){return false;}
                }
              })
            }
          }
        }
//         console.log('1 3',"final_products.length "+final_products.length);
      }
      
      if(final_products.length<4){
        if(prod_type != undefined && color != undefined){
          //1 2
          var temp = $(html).find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"][data-prod_type="'+prod_type+'"][data-color="'+color+'"]');
          if(temp.length>0){
            $.each(temp,function(i,ele){
              var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
              var found = false;
              $.each(final_products,function(ind,val){
                if(val.handle==$(ele).attr('data-handle')){
                  found = true;
                  return false;
                }
              })
              if(found==false){
                if($(ele).attr('data-full-price')=="true"){
                  final_products.push(prod)
                }
                if(final_products.length>=4){return false;}
              }
            })
          }
          if(temp.length<4){
            $.each(temp,function(i,ele){
              var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
              var found = false;
              $.each(final_products,function(ind,val){
                if(val.handle==$(ele).attr('data-handle')){
                  found = true;
                  return false;
                }
              })
              if(found==false){
                if($(ele).attr('data-full-price')=="false"){
                  final_products.push(prod)
                }
                if(final_products.length>=4){return false;}
              }
            })
          }
        }
//         console.log('1 2',"final_products.length "+final_products.length);
      }
		
      if(final_products.length<4){
        if(prod_type != undefined){
          //1
          var temp = $(html).find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"][data-prod_type="'+prod_type+'"]');
//           console.log('Temp: '+temp.length)
          if(temp.length>0){
            
            $.each(temp,function(i,ele){
              var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
//               console.log($(ele).attr('data-full-price'))

              var found = false;
              $.each(final_products,function(ind,val){
                if(val.handle==$(ele).attr('data-handle')){
                  found = true;
                  return false;
                }
              })
              if(found==false){
                if($(ele).attr('data-full-price')=="true"){
                  final_products.push(prod)
                }
                if(final_products.length>=4){return false;}
              }
            })
            if(temp.length<4){
              $.each(temp,function(i,ele){
                var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
                var found = false;
                $.each(final_products,function(ind,val){
                  if(val.handle==$(ele).attr('data-handle')){
                    found = true;
                    return false;
                  }
                })
                if(found==false){
                  if($(ele).attr('data-full-price')=="false"){
                    final_products.push(prod)
                  }
                  if(final_products.length>=4){return false;}
                }
              })
            }
          }
        }
//         console.log('1',"final_products.length "+final_products.length);
      }
      
      
      if(final_products.length<4){
        if(color != undefined){
          //2
          var temp = $(html).find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"][data-color="'+color+'"]');
          if(temp.length>0){
            $.each(temp,function(i,ele){
              var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
              var found = false;
              $.each(final_products,function(ind,val){
                if(val.handle==$(ele).attr('data-handle')){
                  found = true;
                  return false;
                }
              })
              if(found==false){
//                 console.log(prod)
                if($(ele).attr('data-full-price')=="true"){
                  final_products.push(prod)
                }
                if(final_products.length>=4){return false;}
              }
            })
            if(temp.length<4){
              $.each(temp,function(i,ele){
                //                 console.log($(ele).attr('data-full-price'))
                var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
                var found = false;
                $.each(final_products,function(ind,val){
                  if(val.handle==$(ele).attr('data-handle')){
                    found = true;
                    return false;
                  }
                })
                if(found==false){
                  if($(ele).attr('data-full-price')=="false"){
                    final_products.push(prod)
                  }
                  if(final_products.length>=4){return false;}
                }
              })
            }
          }
        }
//         console.log('2',"final_products.length "+final_products.length);
      }
      
      
      if(final_products.length<4){
//         console.log('going to 3')
        if(pfabric != undefined){
          //3
          var temp = $(html).find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"][data-fabric="'+pfabric+'"]');
          if(temp.length>0){
            $.each(temp,function(i,ele){
              var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
              var found = false;
              $.each(final_products,function(ind,val){
                if(val.handle==$(ele).attr('data-handle')){
                  found = true;
                  return false;
                }
              })
              if(found==false){
                if($(ele).attr('data-full-price')=="true"){
                  final_products.push(prod)
                }
                if(final_products.length>=4){return false;}
              }
            })
            if(temp.length<4){
              $.each(temp,function(i,ele){
                var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
                var found = false;
                $.each(final_products,function(ind,val){
                  if(val.handle==$(ele).attr('data-handle')){
                    found = true;
                    return false;
                  }
                })
                if(found==false){
                  if($(ele).attr('data-full-price')=="false"){
                    final_products.push(prod)
                  }
                  if(final_products.length>=4){return false;}
                }
              })
            }
          }
        }
//         console.log('3',"final_products.length "+final_products.length);
      }
      
      var temp = $(html).find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"]');
      if(temp.length>0){
        $.each(products,function(i,ele){
          var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
          if($(ele).attr('data-full-price')=="true"){
            random_prods.push(prod)
          }
        })
      }      
      //       console.log(final_products)
      if(final_products.length>=4){
        showRelatedSection(final_products);
      }
      else{
        var remain = 4-final_products.length;
//         console.log("Show full price random prods: "+remain)
        //Show full price random prods
        showRelatedSectionRandom(random_prods,remain)
      }
      
      
    } //PDP is on Full Price IF ends
    
    else{
      //PDP is on Sale Price
      
      
//       if(color != undefined && pfabric != undefined){
//         //Fabric + Color
//         var temp = $(html).find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"][data-fabric="'+pfabric+'"][data-color="'+color+'"]');
//         if(temp.length>0){
          
//           $.each(temp,function(i,ele){
//             var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
//             var found = false;
//             $.each(final_products,function(ind,val){
//               if(val.handle==$(ele).attr('data-handle')){
//                 found = true;
//                 return false;
//               }
//             })
//             if(found==false){
//               final_products.push(prod)
//               console.log('pushing prod',$(ele).attr('data-handle'),final_products.length);
//             }
//             if(final_products.length>=4){return false;}
//           })
//         }
//         console.log('Fabric + Color: ',"final_products.length "+final_products.length);
//       }

      if(final_products.length<4){
        if(pfabric != undefined){
          //Fabric only
          var found=false;
          var temp = $(html).find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"][data-fabric="'+pfabric+'"]');
          if(temp.length>0){
            $.each(temp,function(i,ele){
              var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
              var found = false;
              $.each(final_products,function(ind,val){
                if(val.handle==$(ele).attr('data-handle')){
                  found = true;
                  return false;
                }
              })
              if(found==false){
                final_products.push(prod)
//                 console.log('pushing prod',$(ele).attr('data-handle'),final_products.length);
              }
              if(final_products.length>=4){return false;}
            })
          }
        }
//         console.log('Fabric only: ',"final_products.length "+final_products.length);
      }

      if(final_products.length<4){
        if(prod_type != undefined && color != undefined){
          //Product Type + Color
          var found=false;
          var temp = $(html).find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"][data-prod_type="'+prod_type+'"][data-color="'+color+'"]');
          if(temp.length>0){
            $.each(temp,function(i,ele){
              var found = false;
              var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
              $.each(final_products,function(ind,val){
                if(val.handle==$(ele).attr('data-handle')){
                  found = true;
                  return false;
                }
              })
              if(found==false){
                final_products.push(prod)
//                 console.log('pushing prod',$(ele).attr('data-handle'),final_products.length);
              }
              if(final_products.length>=4){return false;}
            })
          }
        }
//         console.log('Product Type + Color: ',"final_products.length "+final_products.length);
      }

      
      if(final_products.length<4){
        if(prod_type != undefined){
          //Product Type only
          var temp = $(html).find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"][data-prod_type="'+prod_type+'"]');
//           console.log('Temp: '+temp.length)
          if(temp.length>0){

            $.each(temp,function(i,ele){
              var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
              var found = false;
              $.each(final_products,function(ind,val){
                if(val.handle==$(ele).attr('data-handle')){
                  found = true;
                  return false;
                }
              })
              if(found==false){
                final_products.push(prod)
//                 console.log('pushing prod',$(ele).attr('data-handle'),final_products.length);
              }
              if(final_products.length>=4){return false;}
            })
          }
        }
//         console.log('Product Type only: ',"final_products.length "+final_products.length);
      }
      

      

      var temp = $(html).find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"]');
      if(temp.length>0){
        $.each(products,function(i,ele){
          var prod = {'handle':$(ele).attr('data-handle'),'full_price':$(ele).attr('data-full-price'),'product_type':$(ele).attr('data-prod_type'),'color':$(ele).attr('data-color'),'fabric':$(ele).attr('data-fabric'),'element':ele};
          random_prods.push(prod);
        })
      }      
      //       console.log(final_products)
      if(final_products.length>=4){
        showRelatedSection(final_products,prod_type);
      }
      else{
        
        var remain = 4-final_products.length;
//         console.log("Show Matched random prods: "+remain)
        //Show full price random prods
        showRelatedSectionRandom(final_products,random_prods,remain)
      }
      
    }

  })
  .catch(function(err) {  
    console.log('Failed to fetch page: ', err);  
  });
}
function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}
function appendRemaingProds(data,limit){
  var related_eles = data;
  //   console.log("showRelatedSection called.",related_eles)
  var fi;
  $.each(related_eles,function(ind,val){
    var found = false;
    for (fi = 0; fi < already_added.length; fi++) {
      if(already_added[fi].handle==$(val.element).attr('data-handle')){
        found = true;
      }
    }
    if(found==false){
      total_remains++;
      $(val.element).removeAttr('style');
      $("#similar_products #bc-sf-filter-products").append(val.element);
//       console.log(ind,"remaining added : "+total_remains,$(val.element).attr('data-handle'),"product_type: "+$(val.element).attr('data-prod_type'),"color: "+$(val.element).attr('data-color'),"fabric: "+$(val.element).attr('data-fabric'))
    }
    if(total_remains==limit){return false;}
  })
}

function showRelatedSection(data,prod_type){
  var related_eles = data;
  //   console.log("showRelatedSection called.",related_eles)
  var fi;
  $.each(related_eles,function(ind,val){
    var pair_found = false;
    for (fi = 0; fi < pdp_pairwith.length; fi++) {
      if(pdp_pairwith[fi]==$(val.element).attr('data-handle')){
        pair_found = true;
      }
    }
    if(pair_found==false){
      total_added++;
//       console.log("global_counter: "+total_added,$(val.element).attr('data-handle'),"product_type: "+$(val.element).attr('data-prod_type'),"color: "+$(val.element).attr('data-color'),"fabric: "+$(val.element).attr('data-fabric'))
      $(val.element).removeAttr('style')
      already_added.push(val)
      $("#similar_products #bc-sf-filter-products").append(val.element);
    }
    if(total_added==4){return false;}
  })
  var remain2 = 4-total_added;
  if(remain2>0){
//     console.log(remain2,prod_type)
    var d = $.grep(random_prods, function( n, i ) { 
      return ( n.product_type == prod_type ); 
    });
//     console.log(d)
//     shuffle(d);
    appendRemaingProds(d,remain2);    
  }


  $("#bc-sf-filter-products").removeClass('one_element two_element three_element four_element')
  var total_similars = $("#bc-sf-filter-products .thumbnail").length;
  if(total_similars==1){
    $("#bc-sf-filter-products").addClass('one_element');
  }
  else if(total_similars==2){
    $("#bc-sf-filter-products").addClass('two_element');
  }
  else if(total_similars==3){
    $("#bc-sf-filter-products").addClass('three_element');
  }
  else{
    $("#bc-sf-filter-products").addClass('four_element');
  }
  $("#similar_products").removeClass('hidden');
}
function showRelatedSectionRandom(final_products,data,remain){
  shuffle(data);
  var related_eles = data;
  //   console.log("showRelatedSection called.",related_eles)
  var fi,fi2;
  $.each(final_products,function(ind,val){
    var pair_found = false;
    for (fi = 0; fi < pdp_pairwith.length; fi++) {
      if(pdp_pairwith[fi]==$(val.element).attr('data-handle')){
        pair_found = true;
      }
    }
    if(pair_found==false){
//       console.log("from fin/al prods remainings : "+ind,$(val.element).attr('data-handle'),"product_type: "+$(val.element).attr('data-prod_type'),"color: "+$(val.element).attr('data-color'),"fabric: "+$(val.element).attr('data-fabric'))
      $(val.element).removeAttr('style')
      $("#similar_products #bc-sf-filter-products").append(val.element);
    }
  })

  var final_len = (final_products.length-4) * -1;
//   console.log(final_len)
  $.each(related_eles,function(ind,val){
    var pair_found = false;
    for (fi2 = 0; fi2 < pdp_pairwith.length; fi2++) {
      if(pdp_pairwith[fi2]==$(val.element).attr('data-handle')){
        pair_found = true;
      }
    }
    if(pair_found==false){
      total_added++;
//       console.log("global_counter: "+total_added,$(val.element).attr('data-handle'),"product_type: "+$(val.element).attr('data-prod_type'),"color: "+$(val.element).attr('data-color'),"fabric: "+$(val.element).attr('data-fabric'))
      $(val.element).removeAttr('style')
      $("#similar_products #bc-sf-filter-products").append(val.element);
    }
    if(total_added==final_len){return false;}
  })
  $("#bc-sf-filter-products").removeClass('one_element two_element three_element four_element')
  var total_similars = $("#bc-sf-filter-products .thumbnail").length;
  if(total_similars==1){
    $("#bc-sf-filter-products").addClass('one_element');
  }
  else if(total_similars==2){
    $("#bc-sf-filter-products").addClass('two_element');
  }
  else if(total_similars==3){
    $("#bc-sf-filter-products").addClass('three_element');
  }
  else{
    $("#bc-sf-filter-products").addClass('four_element');
  }
  $("#similar_products").removeClass('hidden');
}




var saleProducts = [],fullPriceProducts = [],final_products = [],random_prods=[];

function recursively_ajax(selectedOptions,prod_handle,full_price,ptype=null,pfabric=null){
  var t= selectedOptions;
  var final_options = t.join('+');
  var path = final_options;
  var d= new Date().getTime();
  $.ajax({
    type:"GET",
    async:"false",
    url: "/collections/all/"+path+"?view=ajax&time="+d,
    success: function(data){
      //           console.warn("get jvm info success");
      var html = $(data);
      var count = html.find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"][data-full-price="true"]').length;
      if(full_price==false){
        count = html.find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"][data-full-price="false"]').length;
      }
//       console.log(count,t)
      if(count<4){
        if((ptype != null && selectedOptions.indexOf(ptype)>=0) && (pfabric != null && selectedOptions.indexOf(pfabric)>=0)){
          console.log(ptype,pfabric)
          console.log('1st ccount 4')
          var fixed_options = [];
          fixed_options.push(ptype);fixed_options.push(pfabric);
          recursively_ajax(fixed_options,prod_handle,full_price,null,null);
        }

      }

      if(count<4){
//         console.log('2nd  ccount 4')
        var prod_data = html.find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"][data-full-price="true"]');
        if(full_price==false){
          //Get sale price prods
          var prod_data2 = html.find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"][data-full-price="false"]');
          var fi;
          $.each(prod_data2,function(i,ele){
            var pair_found = false;
            for (fi = 0; fi < pdp_pairwith.length; fi++) {if(pdp_pairwith[fi]==$(ele).attr('data-handle')){pair_found = true;}}
            if(pair_found==false){
              var found = false;
              $.each(saleProducts,function(ind,val){
                if(val.handle==$(ele).attr('data-handle')){
                  found = true;
                  return false;
                }
              })
              if(found==false){saleProducts.push({'handle':$(ele).attr('data-handle'),'element':ele});}
            }
          })
        }
        var fi;
        $.each(prod_data,function(i,ele){
          var pair_found = false;
          for (fi = 0; fi < pdp_pairwith.length; fi++) {
            if(pdp_pairwith[fi]==$(ele).attr('data-handle')){
              pair_found = true;
            }
          }
          //           console.log(pair_found)
          if(pair_found==false){
            final_count++;
            //             console.log($(ele).attr('data-handle'),'appending')

            var found = false;
            $.each(related_eles,function(ind,val){
              if(val.handle==$(ele).attr('data-handle')){
                found = true;
                return false;
              }
            })
            if(found==false){
              related_eles.push({'handle':$(ele).attr('data-handle'),'element':ele});
            }
          }
          if(pair_found==false){fullPriceProducts.push({'handle':$(ele).attr('data-handle'),'element':ele});}
        })
        //         console.log('inifial_count: '+final_count)
        var newOptions = selectedOptions.pop();
//         console.log(newOptions)
        recursively_ajax(selectedOptions,prod_handle,full_price,null,null);
      }
      else{
        var prod_data = html.find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"][data-full-price="true"]');
        var total = html.find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"][data-full-price="true"]').length;

        if(full_price==false){
          //Get sale price prods
          var prod_data2 = html.find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"][data-full-price="false"]');
          var fi;
          $.each(prod_data2,function(i,ele){
            var pair_found = false;
            for (fi = 0; fi < pdp_pairwith.length; fi++) {if(pdp_pairwith[fi]==$(ele).attr('data-handle')){pair_found = true;}}
            if(pair_found==false){
              var found = false;
              $.each(saleProducts,function(ind,val){
                if(val.handle==$(ele).attr('data-handle')){
                  found = true;
                  return false;
                }
              })
              if(found==false){saleProducts.push({'handle':$(ele).attr('data-handle'),'element':ele});}
            }
          })
          //             total = html.find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"]').length;
        }


        var fi;
        $.each(prod_data,function(i,ele){
          var pair_found = false;
          for (fi = 0; fi < pdp_pairwith.length; fi++) {
            if(pdp_pairwith[fi]==$(ele).attr('data-handle')){
              pair_found = true;
            }
          }
          //           console.log(pair_found)
          if(pair_found==false){
            final_count++;
            //             console.log($(ele).attr('data-handle'),'appending')

            var found = false;
            $.each(related_eles,function(ind,val){
              if(val.handle==$(ele).attr('data-handle')){
                found = true;
                return false;
              }
            })
            if(found==false){
              related_eles.push({'handle':$(ele).attr('data-handle'),'element':ele});
            }
            if(final_count>=4){return false;}
          }
          if(pair_found==false){fullPriceProducts.push({'handle':$(ele).attr('data-handle'),'element':ele});}
        })
        //         $.each(prod_data,function(i,ele){
        //           console.log($(ele).attr('data-handle'),'appending')
        //           final_count++;
        // //           console.log(final_count)

        //           var found = false;
        //           $.each(related_eles,function(ind,val){
        //             if(val.handle==$(ele).attr('data-handle')){
        //               found = true;
        //               return false;
        //             }s
        //           })
        //           if(found==false){
        //             related_eles.push({'handle':$(ele).attr('data-handle'),'element':ele});
        //           }
        //        if(final_count>=4){return false;}   
        // //           $("#similar_products #bc-sf-filter-products").append(ele);
        //         })
        //         console.log("final_count: "+final_count)
//         console.log(related_eles)
        $.each(related_eles,function(ind,val){
          $(val.element).removeAttr('style')
          $("#similar_products #bc-sf-filter-products").append(val.element);
        })
        $("#bc-sf-filter-products").removeClass('one_element two_element three_element four_element')
        var total_similars = $("#bc-sf-filter-products .thumbnail").length;
        if(total_similars==1){
          $("#bc-sf-filter-products").addClass('one_element');
        }
        else if(total_similars==2){
          $("#bc-sf-filter-products").addClass('two_element');
        }
        else if(total_similars==3){
          $("#bc-sf-filter-products").addClass('three_element');
        }
        else{
          $("#bc-sf-filter-products").addClass('four_element');
        }
        $("#similar_products").removeClass('hidden');
      }


    }
  });
}

function getRelatedProds2(selectedOptions,prod_handle,full_price,ptype=null,pfabric=null){  
  var t= selectedOptions;
  var final_options = t.join('+');
  var path = final_options;
  $.ajax({
    type:"GET",
    async:"false",
    url: "/collections/all/"+path+"?view=ajax&time="+new Date().getTime(),
    success: function(data){
      var html = $(data);
      var count = html.find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"]').length;
      var fi;
      var result_prods = html.find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"]');
      //       console.log(result_prods)
//       console.log("Middle call: "+count,t)
      var full_count=0,sale_count=0;
      $.each(result_prods,function(i,ele){
        //Full Price Prods
        var found = false;
        if($(ele).attr('data-full-price')=="true"){
          $.each(fullPriceProducts,function(ind,val){
            if(val.handle==$(ele).attr('data-handle')){
              found = true;
              return false;
            }
          })
          if(found==false){full_count++;fullPriceProducts.push({'handle':$(ele).attr('data-handle'),'element':ele});}
          if(full_count>=4){return false;}
        }

        //Sale Price Prods
        if($(ele).attr('data-full-price')=="false" && fullPriceProducts.length<4){
          var found2 = false;
          $.each(saleProducts,function(ind,val){
            if(val.handle==$(ele).attr('data-handle')){
              found2 = true;
              return false;
            }
          })
          if(found2==false){sale_count++;saleProducts.push({'handle':$(ele).attr('data-handle'),'element':ele});}
          if(sale_count>=4){return false;}
        }
      })
    }
  })
}

function getRelatedProds(selectedOptions,prod_handle,full_price,ptype,pfabric){
  if(full_price==true){
    //     debugger;
    var t= selectedOptions;
    var final_options = t.join('+');
    var path = final_options;
    $.ajax({
      type:"GET",

      url: "/collections/all/"+path+"?view=ajax&time="+new Date().getTime(),
      success: function(data){
        var html = $(data);
        var count = html.find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"]').length;
        var fi;
        var result_prods = html.find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"]');
//         console.log(count,selectedOptions)
        var full_count=0,sale_count=0;
        if(selectedOptions.length>0){
          //           debugger
          $.each(result_prods,function(i,ele){
            //push Full Price Prods
            var found = false;
            if($(ele).attr('data-full-price')=="true"){
              //               debugger
              $.each(fullPriceProducts,function(ind,val){
                if(val.handle==$(ele).attr('data-handle')){
                  //                   debugger
                  found = true;
                  return false;
                }
              })
              if(found==false){

                full_count++;fullPriceProducts.push({'handle':$(ele).attr('data-handle'),'element':ele});
//                 console.log('push full price: '+$(ele).attr('data-handle'))
              }
              if(full_count>=4){return false;}
            }

            //push Sale Price Prods
            if($(ele).attr('data-full-price')=="false" && fullPriceProducts.length<4){
              var found2 = false;
              $.each(saleProducts,function(ind,val){
                if(val.handle==$(ele).attr('data-handle')){
                  //                   debugger
                  found2 = true;
                  return false;
                }
              })
              if(found2==false){
                sale_count++;saleProducts.push({'handle':$(ele).attr('data-handle'),'element':ele});
//                 console.log('push sale price: '+$(ele).attr('data-handle'))
              }
              if(sale_count>=4){return false;}
            }
          })


          if((ptype != null && selectedOptions.indexOf(ptype)>=0) && (pfabric != null && selectedOptions.indexOf(pfabric)>=0)){
            //             debugger
//             console.log(ptype,pfabric)
            var t=[];
            t.push(ptype);t.push(pfabric);
            getRelatedProds2(t,prod_handle,full_price,null,null);
          }
          if(fullPriceProducts.length<=4){
            //             debugger
            var newOptions = selectedOptions.pop();
            getRelatedProds(selectedOptions,prod_handle,full_price,null,null);
          }
        }
        else{
          //           debugger

        }
        //         console.log('fullPriceProducts: '+fullPriceProducts.length,fullPriceProducts)




      }
    }).done(function(data){
      var html = $(data);
      var result_prods = html
//       console.log(result_prods)
      $.each(result_prods,function(i,ele){
        //Full Price Prods
        var found = false;
        if($(ele).attr('data-full-price')=="true"){
          $.each(fullPriceProducts,function(ind,val){
            if(val.handle==$(ele).attr('data-handle')){
              found = true;
              return false;
            }
          })
          if(found==false){
            full_count++;random_prods.push({'handle':$(ele).attr('data-handle'),'element':ele});
            //                 console.log('Random push full price: '+$(ele).attr('data-handle'))
          }
        }

        //Sale Price Prods
        if($(ele).attr('data-full-price')=="false" && fullPriceProducts.length<4){
          var found2 = false;
          $.each(saleProducts,function(ind,val){
            if(val.handle==$(ele).attr('data-handle')){
              found2 = true;
              return false;
            }
          })
          if(found2==false){
            sale_count++;random_prods.push({'handle':$(ele).attr('data-handle'),'element':ele});
            //                 console.log('Random push sale price: '+$(ele).attr('data-handle'))
          }
        }
      })
      if(fullPriceProducts.length<4){
        final_products = fullPriceProducts.concat(saleProducts);
      }
      else{
        final_products = fullPriceProducts;
      }

      if(final_products.length>0){
//         console.log(final_products)
        showRelatedSection(final_products,4);
      }
      //       if(final_products.length<4){
      //         showRelatedSection(random_prods,4);
      //       }
    })
  }
  else{
    //Full price = false
    var t= selectedOptions;
    var final_options = t.join('+');
    var path = final_options;
    $.ajax({
      type:"GET",
      async:"false",
      url: "/collections/all/"+path+"?view=ajax&time="+new Date().getTime(),
      success: function(data){
        var html = $(data);
        var count = html.find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"]').length;
        var fi;
        var result_prods = html.find("#bc-sf-filter-products").find('.thumbnail[data-available="true"][data-handle !="'+prod_handle+'"]');
//         console.log(count,selectedOptions)
        var full_count=0,sale_count=0;
        $.each(result_prods,function(i,ele){
          //Full Price Prods
          var found = false;
          if($(ele).attr('data-full-price')=="true"){
            $.each(fullPriceProducts,function(ind,val){
              if(val.handle==$(ele).attr('data-handle')){
                found = true;
                return false;
              }
            })
            if(found==false){full_count++;fullPriceProducts.push({'handle':$(ele).attr('data-handle'),'element':ele});}
            if(full_count>=4){return false;}
          }

          //Sale Price Prods
          if($(ele).attr('data-full-price')=="false"){
            var found2 = false;
            $.each(saleProducts,function(ind,val){
              if(val.handle==$(ele).attr('data-handle')){
                found2 = true;
                return false;
              }
            })
            if(found2==false){sale_count++;saleProducts.push({'handle':$(ele).attr('data-handle'),'element':ele});}
            if(sale_count>=4){return false;}
          }
        })
        if((ptype != null && selectedOptions.indexOf(ptype)>=0) && (pfabric != null && selectedOptions.indexOf(pfabric)>=0)){
//           console.log(ptype,pfabric)
          var t=[];
          t.push(ptype);t.push(pfabric);
          getRelatedProds2(t,prod_handle,full_price,null,null);
        }
        if(fullPriceProducts.length<=4){
          var newOptions = selectedOptions.pop();
          getRelatedProds(selectedOptions,prod_handle,full_price,null,null);
        }

        if(saleProducts.length>=4){
//           console.log('Sale SalePriceProducts: '+saleProducts.length)
          final_products.contact(saleProducts)
          //           return false;
        }
        else{
          var d= saleProducts.concat(fullPriceProducts);
//           console.log('Sale d: '+final_products.length)
          final_products= d
        }

//         console.log('final_products: '+final_products.length)
        if(final_products.length>0){
          console.log(final_products)
          showRelatedSection(final_products,4);
        }
      }
    })

  }


}

